import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbAccordionModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { CRUDTableModule } from './crud-table';
import { CreateEditModalComponent } from './create-edit-modal/create-edit-modal.component';
import { ErrorImportModalComponent } from './error-import-modal/error-import-modal.component';
import { OrganizationSelectorComponent } from './organization-selector/organization-selector.component';
import { ShareService } from '../../services/shared.service';
import { FiscalYearSelectorComponent } from './fiscal-year-selector/fiscal-year-selector.component';
import { CreateEditModalV2Component } from './create-edit-modal-v2/create-edit-modal-v2.component';
import { MasterAttachmentComponent } from './master-attachment/master-attachment.component';
import { ApproveRejectModalComponent } from './approve-reject-modal/approve-reject-modal.component';
import { EquipmentDetailModalComponent } from './equipment-detail-modal/equipment-detail-modal.component';



@NgModule({
  declarations: [
    ConfirmModalComponent,
    CreateEditModalComponent,
    ErrorImportModalComponent,
    OrganizationSelectorComponent,
    FiscalYearSelectorComponent,
    CreateEditModalV2Component,
    MasterAttachmentComponent,
    ApproveRejectModalComponent,
    EquipmentDetailModalComponent,
    
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    NgxDatatableModule,
    BsDatepickerModule.forRoot(),
    NgbAccordionModule,
    CRUDTableModule,
  ],
  providers: [
    ShareService
  ],
  exports: [
    ConfirmModalComponent,
    OrganizationSelectorComponent,
    FiscalYearSelectorComponent,
    MasterAttachmentComponent
  ],
})
export class SharedComponentModule { }
